import { useCallback } from 'react'
import { ethers, Contract } from 'ethers'
import { useConditionalLiquidity } from 'hooks/useContract'
import { useCallWithGasPrice } from 'hooks/useCallWithGasPrice'
import { addRule, depositCL, withdrawCL } from 'utils/calls/conditionalLiquidity'
import { TransactionResponse } from '@ethersproject/providers'

const useClpHandlers = () => {
  const cl = useConditionalLiquidity()
  const { callWithGasPrice } = useCallWithGasPrice()

  const handleApprove = useCallback(
    async (lpContract: Contract) => {
      try {
        const tx = await callWithGasPrice(lpContract, 'approve', [cl.address, ethers.constants.MaxUint256])
        const receipt = await tx.wait()
        return receipt.status
      } catch (e) {
        return false
      }
    },
    [cl, callWithGasPrice],
  )

  const handleAddRule = useCallback(
    async (
      lpAddress: string,
      token0Amount: string,
      decimals0: number,
      token1Amount: string,
      decimals1: number,
      deadline: number,
    ): Promise<TransactionResponse> => {
      return addRule(cl, lpAddress, token0Amount, decimals0, token1Amount, decimals1, deadline)
    },
    [cl],
  )

  const handleDeposit = useCallback(
    async (lpAddress: string, amount: string): Promise<TransactionResponse> => {
      return depositCL(cl, lpAddress, amount)
    },
    [cl],
  )

  const handleWithdraw = useCallback(
    async (lpAddress: string, amount: string): Promise<TransactionResponse> => {
      return withdrawCL(cl, lpAddress, amount)
    },
    [cl],
  )

  return {
    onApprove: handleApprove,
    onAddRule: handleAddRule,
    onDeposit: handleDeposit,
    onWithdraw: handleWithdraw,
  }
}

export default useClpHandlers
